import { memo } from "react";
import { toast } from "react-toastify";
import { PrimaryButton } from "common";

import { Modal } from "components/Modal";

const getIsInAppBrowser = () => {
    const ua = navigator.userAgent;

    return /FBAN|FBAV|Instagram|Line|WhatsApp/i.test(ua);
};

export const BrowserDetectModal = memo(() => {
    const isInAppBrowser = getIsInAppBrowser();

    if (!isInAppBrowser) {
        return null;
    }

    const pageUrl = window.location.href;

    return <Modal isModalOpen>
        <p className="text-center">Please copy and paste this link into your phone's browser</p>
        <p className="text-center break-all max-w-md">{pageUrl}</p>
        <PrimaryButton label='Copy' onClick={() => {
            toast.info("Link copied to clipboard", {autoClose: 1500});
            navigator.clipboard.writeText(pageUrl);
        }} />

    </Modal>;
}
);